/**
 * @param templateData 标准化格口信息
 */
export function normalizeTemplateLayers(templateData: any) {
  templateData = templateData || {}

  const totalLayers = templateData.layers || 3
  const template = templateData.template || []

  let templateCells: any[] = template || []

  if (typeof template === 'string') {
    try {
      templateCells = JSON.parse(template)
    } catch (ex) {}
  }

  const allCells = (templateCells || []).sort((a: any, b: any) => a.pos - b.pos) // 按位置排序

  // 初始化层数据
  const layers = [
    {
      layer: 3,
      visible: true,
      sideCount: 2,
      sides: [
        { code: 'A', cells: [] },
        { code: 'B', cells: [] }
      ]
    },
    {
      layer: 2,
      visible: true,
      sideCount: 2,
      sides: [
        { code: 'A', cells: [] },
        { code: 'B', cells: [] }
      ]
    },
    {
      layer: 1,
      visible: true,
      sideCount: 1,
      sides: [{ code: 'A', cells: [] }]
    }
  ]

  // 初始化模版信息
  layers.forEach(it => {
    // 不显示超过总层数的层
    if (it.layer > totalLayers) {
      it.visible = false
    }

    // 获取当前层所有格口
    const layerCells = allCells.filter((cell: any) => cell.layer === it.layer)

    // 获取当前格口所有面，并分配格口数据
    it.sides.forEach(side => {
      side.cells = layerCells.filter((cell: any) => cell.side === side.code)
    })

    const sideWidthCells = it.sides.filter(it => !!it.cells.length).length

    it.sideCount = sideWidthCells > 0 ? sideWidthCells : 1
  })

  return layers
}

/**
 * 获取格口真实信息
 */
export function retrieveTemplateCells(templateLayers: any[], layerCount: number) {
  const validateLayers = templateLayers.filter((it: any) => it.layer <= layerCount)

  const cells: any[] = []

  validateLayers.forEach((l: any) => {
    if (!l?.sides?.length) return

    l.sides.forEach((s: any, sIndex: number) => {
      // 过滤掉不显示的面
      if (l.sideCount && sIndex >= l.sideCount) return

      if (!s?.cells.length) return
      cells.push(...s?.cells)
    })
  })

  return cells
}

/**
 * 获取重复的格口号
 */
export function retrieveRepeatedCellNums(templateCells: any[]) {
  const allNums = templateCells.map(it => it.num)

  const seen = new Set()
  const repeated = new Set()

  allNums.forEach(it => {
    if (seen.has(it)) {
      repeated.add(it)
    } else {
      seen.add(it)
    }
  })

  return [...repeated]
}

// 验证模版格口
export function validateTemplateCells(templateCells: any[]) {
  let errorMessage = ''

  // 检测重复空的格口
  const emptyCells = templateCells.filter((it: any) => typeof it.num !== 'number' || !it.name)

  if (emptyCells.length) {
    const invalidCell = emptyCells[0]

    errorMessage = `请设置 第${invalidCell.layer}层${invalidCell.side}面第${invalidCell.pos + 1}个格口 的`

    let emptyField = ''

    if (!invalidCell.num && !invalidCell.name) {
      emptyField = '格口名称和格口号'
    } else if (!invalidCell.num) {
      emptyField = '格口号'
    } else if (!invalidCell.name) {
      emptyField = '格口名称'
    }

    errorMessage += emptyField

    return errorMessage
  }

  // 检测重复的格口号
  const repeatedNums = retrieveRepeatedCellNums(templateCells)
  if (repeatedNums.length) {
    errorMessage = '格口号 ' + repeatedNums.join() + '重复'
    return errorMessage
  }

  return errorMessage
}
